const oilCoalEvolution = {
  brentOil: {
    origin: 'Brent Oil M+1',
    currency: '$/bbl',
  },
  coal: {
    origin: 'Coal API2 CAL Y+1',
    currency: '$/tonne',
  },
  eua: {
    origin: 'EUA Dec 25',
    currency: '€/tonne',
  },
  ukEts: {
    origin: 'UK ETS Dec 25',
    currency: '£/tonne',
  },
};

export default oilCoalEvolution;
